export default function fetchService(fetchMethod) {
  return {
    type: 'FETCH',
    fetch: fetchMethod,
  };
}
